import { ApiTags, rootApi } from "../../../../services/rootApi";
import { IShuttleBookings } from "./shuttleBooking";


const TAG = ApiTags.ShuttleBooking;
const getTags = (entities: IShuttleBookings[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const shuttleDetailsApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getBookings: builder.query<IShuttleBookings[], { contactId: string, bookingStatus: number }>({
      query: ({ contactId, bookingStatus }) => `/ShuttleDetails/contact(${contactId})/${bookingStatus}`,
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),
  })
})

export const {
  useGetBookingsQuery,
  useLazyGetBookingsQuery,
} = shuttleDetailsApi;